import React, { useState, useEffect } from 'react';
import { UploadOutlined } from '@ant-design/icons';
import type { UploadProps as AntdUploadProps, UploadFile } from 'antd';
import { registerComponentProperty } from '../util/util'
import { Upload as AntdUpload, Button, message } from 'antd';

export type UploadProps = AntdUploadProps & {
  maxSize?: number
  value?: UploadFile[]
  onChange?: (fileList: UploadFile[]) => void
}

const ButtonUploader = (props: UploadProps) => {
  const metaElement = document.querySelector(
    'meta[name="csrf-token"]'
  ) as HTMLMetaElement
  const maxSize = props.maxSize // 不设置默认值，在 beforeUpload 中根据文件类型动态设置
  const [fileList, setFileList] = useState<UploadFile[]>(props.value || []);

  useEffect(() => {
    if (props.value !== undefined) {
      setFileList(props.value);
    }
  }, [props.value]);

  const handleChange: UploadProps['onChange'] = (info) => {
    let newFileList = [...info.fileList];

    newFileList = newFileList.map((file) => {
      if (file.response) {
        file.url = file.response.url;
      }
      return file;
    });

    setFileList(newFileList);
    
    if (props.onChange) {
      props.onChange(newFileList);
    }
  }

  const beforeUpload = (file) => {
    const isImage = file.type.startsWith('image/')
    
    let sizeLimit = maxSize
    if (!maxSize) {
      sizeLimit = isImage ? 1024 * 2 : 1024 * 10 // 图片2M，其他10M
    }

    const fileSizeInKB = file.size / 1024
    const inLimit = fileSizeInKB < sizeLimit

    if (!inLimit) {
      file.status = "removed"
      const sizeLimitInMB = (sizeLimit / 1024).toFixed(1)
      const fileType = isImage ? '图片' : '文件'
      message.error(`${fileType}大小不能超过 ${sizeLimitInMB}MB!`)
    }

    return inLimit
  }

  const { value, onChange, ...restProps } = props;

  return (
    <AntdUpload
      {...restProps}
      fileList={fileList}
      onChange={handleChange}
      action={props.action || "/api/v1/attachments/upload"}
      beforeUpload={beforeUpload}
      headers={{
        "X-CSRF-Token": metaElement.content,
      }}
      name="file"
    >
      <Button icon={<UploadOutlined />}>点击上传</Button>
    </AntdUpload>
  )
}

export default registerComponentProperty<typeof ButtonUploader, typeof AntdUpload>(ButtonUploader, AntdUpload)